module.exports = __webpack_public_path__ + "static/media/Exit.8e288337.svg";